export var _baseSheetTheme = {
  baseStyle: _ref => {
    var {
      placement,
      showCloseButton
    } = _ref;
    return {
      mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: '88px',
        maxHeight: placement === 'bottom' ? '95vh' : 'inherit',
        borderTopRightRadius: placement === 'bottom' ? 'l' : 'xxl',
        borderTopLeftRadius: placement === 'bottom' ? 'l' : 'none',
        borderBottomRightRadius: placement === 'left' ? 'xxl' : 'none',
        backgroundColor: 'neutral.white'
      },
      loadingContainer: {
        minHeight: 'inherit',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 'm',
        paddingTop: showCloseButton ? 'xl' : 'm'
      },
      closeButtonContainer: {
        position: 'absolute',
        top: 's',
        right: 's',
        zIndex: 1
      }
    };
  }
};
//# sourceMappingURL=_BaseSheet.theme.js.map